import PageTemplate from '../../components/ui/PageTemplate';
import useObserver from '@/hooks/page/useObserver';
import ProductNavBar from './ProductNavBar';
import RFIScanner from './RFIScanner';
import { useState } from 'react';
import ConstellationDesigner from './ConstellationDesigner';
import SpaceScanner from './SpaceScanner';
import AstroOne from './AstroOne';
import AstroOrca from './AstroOrca';
import AstroLibrary from './AstroLibrary';
import Abacus from './Abacus';

const Product = () => {
  useObserver(
    'content-Product',
    'content-Product-tablet',
    'content-Product-desktop'
  );
  const [activeProduct, setActiveProduct] = useState('RFI Scanner');
  const [isTransitioning, setIsTransitioning] = useState(false);

  const handleProductChange = (product: string) => {
    if (product !== activeProduct) {
      setIsTransitioning(true);
      setTimeout(() => {
        setActiveProduct(product);
        setIsTransitioning(false);
      }, 150);
    }
  };

  const renderProductComponent = () => {
    switch (activeProduct) {
      case 'RFI Scanner':
        return <RFIScanner />;
      case 'Constellation Designer':
        return <ConstellationDesigner />;
      case 'Space Scanner':
        return <SpaceScanner />;
      case 'Astro-1':
        return <AstroOne />;
      case 'AstroOrca':
        return <AstroOrca />;
      case 'AstroLibrary':
        return <AstroLibrary />;
      case 'Abacus':
        return <Abacus />;
      default:
        return null;
    }
  };

  return (
    <PageTemplate id='Product'>
      {/* Mobile & Tablet Layout */}
      <div
        id='content-Product'
        className='xl:hidden w-full flex flex-col py-20 gap-10 relative'
      >
        <div className='flex flex-col gap-10 md:gap-24 w-full max-w-[360px] md:max-w-[688px] mx-auto'>
          <div className='flex flex-row items-center md:justify-between gap-3 px-4 md:px-0'>
            <h1 className='text-[20px] md:text-[30px] font-semibold text-[#FFFFFF]'>
              Product
            </h1>
            <div className='w-full md:hidden'>
              <ProductNavBar
                activeProduct={activeProduct}
                onProductChange={handleProductChange}
                variant="dropdown"
              />
            </div>
            <div className='hidden md:block xl:hidden mt-2 md:mt-0'>
              <ProductNavBar
                activeProduct={activeProduct}
                onProductChange={handleProductChange}
                variant="dropdown"
              />
            </div>
          </div>
          <div className='flex flex-col gap-4 md:gap-8'>
            <div className='flex flex-col w-full gap-6'>
              <div
                className={`transition-opacity duration-300 ease-in-out ${
                  isTransitioning ? 'opacity-0' : 'opacity-100'
                }`}
              >
                {renderProductComponent()}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Layout */}
      <div
        id='content-Product-desktop'
        className='hidden xl:flex w-full max-w-[1060px] mx-auto h-full flex-col py-36 gap-16 relative'
      >
        <div className='flex flex-col'>
          <h1 className='text-[28px] font-semibold text-[#FFFFFF]'>Product</h1>
        </div>

        <div className='relative z-20 flex flex-col gap-14 w-full'>
          <div className='flex flex-col w-full h-full'>
            <div
              className={`transition-opacity duration-300 ease-in-out ${
                isTransitioning ? 'opacity-0' : 'opacity-100'
              }`}
            >
              {renderProductComponent()}
            </div>
          </div>
          <div className='flex flex-col w-full h-fit'>
            <ProductNavBar
              activeProduct={activeProduct}
              onProductChange={handleProductChange}
            />
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default Product;
